type Props = {
    title: string,
    onSuccess: () => void,
    onCancel: () => void
}

export default function LeaveChannelModal({ title, onSuccess, onCancel }: Props) {
	return (
		<div id="confirmLeave" className="modal">
			<div className="modal-background" onClick={onCancel}></div>
			<div className="modal-content">
				<div className="modal-card">
					<div className="modal-card-content">
						<p className="modal-title">{title}</p>
						<div className="modal-buttons">
							<button className="modal-button cancel" onClick={onCancel}>Cancel</button>
							<button className="modal-button confirm" onClick={onSuccess}>Leave</button>
						</div>
					</div>
				</div>
			</div>
			<button className="modal-close is-large" aria-label="close" onClick={onCancel}></button>

			<style>{`
				.modal-card{
					width: unset !important;
				}
				.modal {
					display: none;
					position: fixed;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					align-items: center;
					justify-content: center;
					z-index: 1000;
				}

				.modal.is-active {
					display: flex;
				}

				.modal-background {
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					background-color: rgba(0, 0, 0, 0.3);
					backdrop-filter: blur(4px);
				}

				.modal-content {
					position: relative;
					width: 100%;
					max-width: 300px;
					margin: 0 auto;
				}

				.modal-card {
					background: #ffffff;
					border-radius: 14px;
					overflow: hidden;
					box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
				}

				.modal-card-content {
					padding: 1.5rem;
				}

				.modal-title {
					font-size: 1.25rem;
					font-weight: 600;
					color: #000;
					text-align: center;
					margin-bottom: 1.5rem;
				}

				.modal-buttons {
					display: flex;
					gap: 1rem;
					justify-content: center;
				}

				.modal-button {
					padding: 0.75rem 1.5rem;
					border-radius: 10px;
					font-weight: 600;
					font-size: 1rem;
					border: none;
					cursor: pointer;
					transition: all 0.2s ease;
				}

				.modal-button.cancel {
					background: #f2f2f7;
					color: #007AFF;
				}

				.modal-button.confirm {
					background: #ff3b30;
					color: #ffffff;
				}

				.modal-button:hover {
					opacity: 0.9;
					transform: translateY(-1px);
				}

				.modal-close {
					background: none;
					border: none;
					cursor: pointer;
				}

				@media (max-width: 768px) {
					.modal-content {
						margin: 0 0.75rem;
					}

					.modal-card-content {
						padding: 1.25rem;
					}

					.modal-title {
						font-size: 1.125rem;
					}

					.modal-button {
						padding: 0.625rem 1.25rem;
						font-size: 0.9375rem;
					}
				}
			`}</style>
		</div>
	);
}